import _classCallCheck from "/var/log/nginx/source/CateringManagerX/CateringManager_Html/node_modules/_@babel_runtime-corejs2@7.13.7@@babel/runtime-corejs2/helpers/esm/classCallCheck";

/**
 * 公共接口结果类
 */
export var TemplateResultClass = function TemplateResultClass() {
  _classCallCheck(this, TemplateResultClass);
};
/**
 * 公共分页类
 */

export var pagination = function pagination() {
  _classCallCheck(this, pagination);
};
/**
 * 当前文件请求接口头地址
 */

export var urlDesignFaceTeachQuestionnaire = '/api/XOrg/FaceTeachQuestionnaire/';
import http from 'lib//http';
/**
 * 获取问卷调查列表url
 */

export var urlGetQuestionnaireList = urlDesignFaceTeachQuestionnaire + 'getFaceTeachQuestionnaireList';
/**
 * 获取问卷调查列表result
 */

export var QuestionnaireList = function QuestionnaireList() {
  _classCallCheck(this, QuestionnaireList);
};
/**
 * 获取问卷调查列表function
 */

export function getQuestionnaireList(courseId, classId, faceId, classState, page, questionnaireName) {
  return http.post(urlGetQuestionnaireList, {
    courseId: courseId,
    classId: classId,
    faceId: faceId,
    questionnaireName: questionnaireName,
    classState: classState,
    page: page
  });
}
/**
 * 获取问卷调查题目列表url
 */

export var urlGetQuestionnaireQuestionList = urlDesignFaceTeachQuestionnaire + 'getQuestionnaireStatistics';
/**
 * 获取问卷调查题目列表result
 */

export var QuestionnaireQueList = function QuestionnaireQueList() {
  _classCallCheck(this, QuestionnaireQueList);
};
/**
 * 获取问卷调查题目列表function
 * @param activityId
 * @param classId
 * @param questionnaireId
 */

export function getQuestionnaireQueList(activityId, classId, questionnaireId) {
  return http.post(urlGetQuestionnaireQuestionList, {
    activityId: activityId,
    classId: classId,
    questionnaireId: questionnaireId,
    type: 1
  });
}
/**
 * 新建问卷调查url
 */

export var urlAddQuestionnaire = urlDesignFaceTeachQuestionnaire + 'addFaceTeachQuestionnaire';
/**
 * TemplateResultClass 公共返回值类型
 */

/**
 * 新建问卷调查function
 * @param courseId
 * @param classId
 * @param faceId
 * @param questionnaireName 问卷调查的名称
 * @param classState 1课前/2课中/3课后
 */

export function addQuestionnaire(courseId, classId, faceId, questionnaireName, classState) {
  return http.post(urlAddQuestionnaire, {
    courseId: courseId,
    classId: classId,
    faceId: faceId,
    questionnaireName: questionnaireName,
    classState: classState
  });
}
/**
 * 重命名问卷调查url
 */

export var urlRenameQuestionnaire = urlDesignFaceTeachQuestionnaire + 'updateQuestionnaireTitle';
/**
 * TemplateResultClass 公共返回值类型
 */

/**
 * 重命名问卷调查function
 * @param questionnaireId 问卷id
 * @param questionnaireName 问卷名称
 */

export function renameQuestionnaire(questionnaireId, questionnaireName) {
  return http.post(urlRenameQuestionnaire, {
    questionnaireId: questionnaireId,
    title: questionnaireName
  });
}
/**
 * 开始问卷调查url
 */

export var urlStartQuestionnaire = urlDesignFaceTeachQuestionnaire + 'startQuestionnaire';
/**
 * TemplateResultClass 公共返回值类型
 */

/**
 * 开始问卷调查function
 * @param questionnaireId 问卷id
 */

export function startQuestionnaire(questionnaireId) {
  return http.post(urlStartQuestionnaire, {
    Id: questionnaireId
  });
}
/**
 * 结束问卷调查url
 */

export var urlEndQuestionnaire = urlDesignFaceTeachQuestionnaire + 'endQuestionnaire';
/**
 * TemplateResultClass 公共返回值类型
 */

/**
 * 结束问卷调查function
 * @param questionnaireId 问卷id
 */

export function endQuestionnaire(questionnaireId) {
  return http.post(urlEndQuestionnaire, {
    Id: questionnaireId
  });
}
/**
 * 删除问卷调查url
 */

export var urlDelQuestionnaire = urlDesignFaceTeachQuestionnaire + 'delQuestionnaire';
/**
 * TemplateResultClass 公共返回值类型
 */

/**
 * 删除问卷调查function
 * @param questionnaireId 问卷id
 */

export function delQuestionnaire(questionnaireId) {
  return http.post(urlDelQuestionnaire, {
    Id: questionnaireId
  });
}
/**
 * 新建或修改问卷调查题目url
 */

export var addQuestionnaireQuestionUrl = urlDesignFaceTeachQuestionnaire + 'addQuestionnaireDetail';
/**
 * TemplateResultClass 公共返回值类型
 */

/**
* 新建或修改问卷调查题目function
*/

export function addQuestionnaireQuestion(faceId, questionnaireId, questionId, title, dataJson, answer, questionType, sortOrder) {
  return http.post(addQuestionnaireQuestionUrl, {
    faceId: faceId,
    questionnaireId: questionnaireId,
    questionId: questionId,
    title: title,
    dataJson: dataJson,
    answer: answer,
    questionType: questionType,
    sortOrder: sortOrder
  });
}
/**
 * 删除问卷调查题目url
 */

export var urlDeleteQuestionnaireQuestion = urlDesignFaceTeachQuestionnaire + 'delQuestion';
/**
 * TemplateResultClass 公共返回值类型
 */

/**
 * 删除问卷调查题目function
 * 删除最后一题需要传问卷id删除问卷，反之传空字符串
 */

export function deleteQuestionnaireQuestion(questionId, questionnireId) {
  return http.post(urlDeleteQuestionnaireQuestion, {
    questionId: questionId,
    questionnireId: questionnireId
  });
}
/**
 * 父页面统一提交问卷调查题目url
 */

export var urlSubmitAllQuestion = '/api/XOrg/BookMaterial/updateQuestionnaireQuestions';
/**
 * TemplateResultClass 公共返回值类型
 */

/**
 * 父页面统一提交问卷调查题目function
 */

export function submitAllQuestion(faceId, questionnaireId, questionnaireName, questionJson, classState, faceTeachState) {
  return http.post(urlSubmitAllQuestion, {
    faceId: faceId,
    questionnaireId: questionnaireId,
    questionnaireName: questionnaireName,
    questionJson: questionJson,
    classState: classState,
    faceTeachState: faceTeachState
  });
}